
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsCheckbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 13,
  viewBox: "0 0 17 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.205 2.134 14.191.12a.408.408 0 0 0-.578 0L6.195 7.538l-3.48-3.49a.41.41 0 0 0-.578 0L.12 6.059a.411.411 0 0 0 0 .579l5.782 5.798a.408.408 0 0 0 .579 0l9.724-9.724a.405.405 0 0 0 0-.578z",
  fill: "#FFF",
  fillRule: "nonzero"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"13\" viewBox=\"0 0 17 13\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"#FFF\" fill-rule=\"nonzero\">\r\n            <g>\r\n                <g>\r\n                    <g>\r\n                        <path d=\"M19.205 7.134L17.191 5.12c-.16-.16-.419-.16-.578 0l-7.418 7.418-3.48-3.49c-.076-.076-.18-.12-.289-.12-.108 0-.212.043-.289.12L3.12 11.059c-.076.077-.12.18-.12.289 0 .109.043.213.12.29l5.782 5.798c.077.077.18.12.29.12.108 0 .212-.043.289-.12l9.724-9.724c.077-.076.12-.18.12-.289 0-.108-.043-.212-.12-.289z\" transform=\"translate(-327 -284) translate(0 86) translate(16 174) translate(308 19)\"/>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-checkbox.860cd215f5e944dbd9f9782e054b5522.svg"),
        {
          React: SvgIconsCheckbox,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      